import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { FiEdit3 } from "react-icons/fi";

const AddSocietyAdmin = () => {
  const navigate = useNavigate();
  const { email } = useParams();

  const [adminData, setAdminData] = useState({
    adminName: "", startDate: "", adminPhoneNo: "", endDate: "", adminEmail: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    fetch(`https://backend.devaccounts.com/api/get-admin-by-email/${email}`, {
      method: "GET",
      headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
    })
      .then((res) => res.ok ? res.json() : Promise.reject(res))
      .then((data) => setAdminData(data))
      .catch((err) => console.error(err));
  }, [email]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdminData(prev => ({ ...prev, [name]: value }));
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    fetch(`https://backend.devaccounts.com/api/update-society-admin/${email}`, {
      method: "POST",
      headers: { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" },
      body: JSON.stringify(adminData),
    })
      .then(res => res.ok ? res.text() : Promise.reject(res))
      .then(msg => {
        alert("Admin updated successfully!");
        window.location.reload();
      })
      .catch(err => alert("Update failed"));
  };

  const renderInput = (label, name, type = "text") => (
    <div className="flex flex-col gap-1">
      <label className="text-xs font-bold text-text-muted uppercase tracking-wider">{label}</label>
      <input
        type={type}
        name={name}
        value={type === 'date' && adminData[name] ? adminData[name].split('T')[0] : adminData[name] || ""}
        onChange={handleChange}
        className="w-full bg-bg-input border border-border rounded px-4 py-3 text-text-main focus:outline-none focus:border-signal-orange transition-colors"
      />
    </div>
  );

  return (
    <div className="flex min-h-screen bg-bg-primary text-text-main font-satoshi transition-colors duration-300">
      <Sidebar />
      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        <Header />

        <main className="flex-1 overflow-y-auto p-6 md:p-12 relative">
          <div className="max-w-3xl mx-auto">
            <div className="mb-10 pb-6 border-b border-border">
              <h1 className="text-3xl font-clash font-bold text-text-main flex items-center gap-3">
                Edit Administrator <FiEdit3 className="text-signal-lime" />
              </h1>
              <p className="text-text-muted mt-1">Modify access details for {adminData.adminEmail}</p>
            </div>

            <form onSubmit={handleUpdate} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {renderInput("Admin Name", "adminName")}
                {renderInput("Phone Number", "adminPhoneNo")}
                {renderInput("Start Date", "startDate", "date")}
                {renderInput("End Date", "endDate", "date")}
                <div className="md:col-span-2">
                  {renderInput("Email Address", "adminEmail", "email")}
                </div>
              </div>

              <div className="pt-8 text-right">
                <button type="submit" className="px-8 py-3 bg-signal-lime text-noir-900 font-bold uppercase tracking-wide hover:bg-lime-400 transition-colors rounded shadow-lg shadow-lime-900/20">
                  Update Records
                </button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AddSocietyAdmin;
